import styled, { ITheme } from 'styled-components';

export const Wrapper = styled.div`
    width: 60%;
    /* max-width: 812px; */
    position: absolute;
    bottom: 0;
    left: calc((1440px - 1272px) / 2);
    /* left: 25%; */
    background: ${({ theme }: { theme: ITheme }) => theme.dark2};
    border-width: 1px 0px;
    border-style: solid;
    border-color: ${({ theme }: { theme: ITheme }) => theme.green6};
    .box-banner {
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        .item-banner {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: ${({ theme }: { theme: ITheme }) => theme.green1};
            .hint-banner {
                width: 100px;
            }
            .percent {
                margin-left: 4px;
                margin-right: 12px;
            }
            .text-banner {
                margin-right: 12px;
            }
        }
    }
    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        width: 100%;
        margin-left: 0;
        margin-top: 30px;
        position: unset;
        overflow: scroll;
        &::-webkit-scrollbar {
            height: 0.5em;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(255, 255, 255, 0.1);
            border-radius: 2px;

            &:hover {
                background: rgba(255, 255, 255, 0.2);
            }
        }
        .box-banner {
            width: 100%;
            .item-banner {
                padding: 0 15px;
                .percent,
                .text-banner {
                    font-size: 24px;
                    line-height: 40px;
                }
            }
        }
    `}
`;
